import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs';
import { AutoSavePersistService } from 'common/auto-save/auto-save-persist.service';
import { evictMessageConversation } from '../actions/message-conversation.actions';
import { getMessageDraftStorageKey } from '../helpers/message-drafts.helpers';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudMessageDraftsEffects {
  readonly clearMessageDraft$ = createEffect(() => this.actions$.pipe(
    ofType(evictMessageConversation),
    map(({ conversationId }) => getMessageDraftStorageKey(conversationId)),
    tap(storageKey => this.autoSavePersistService.clear(storageKey))
  ), { dispatch: false });

  constructor(private readonly actions$: Actions,
              private readonly autoSavePersistService: AutoSavePersistService) {
  }
}
